import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 11a1 1 0 0 1 .117 1.993L10 13H7v13h18V13h-3a1 1 0 0 1-.117-1.993L22 11h3a2 2 0 0 1 1.994 1.85L27 13v13a2 2 0 0 1-1.85 1.994L25 28H7a2 2 0 0 1-1.995-1.85L5 26V13a2 2 0 0 1 1.85-1.995L7 11zm6.613-9.79.094.083 5.25 5.248a1 1 0 0 1-1.32 1.498l-.094-.083L17 4.414V16a1 1 0 0 1-1.993.117L15 16V4.412l-3.543 3.544a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.095 5.25-5.248a1 1 0 0 1 1.32-.083"
    />
  </svg>
);
const SvgIconExport = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconExport);
export default Memo;
